var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rd-shell" }, [
    _c(
      "header",
      { staticClass: "rd-header" },
      [_vm._m(0), _c("DesignMenuBar", { on: { action: _vm.onMenuAction } })],
      1
    ),
    _c(
      "div",
      { staticClass: "rd-stage" },
      [
        _vm.hasGeneratedProtocol
          ? _c(
              "div",
              {
                staticClass: "rd-module-tabs",
                attrs: { role: "tablist", "aria-label": "Module content" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "rd-module-tab",
                    class: { "is-active": _vm.activeConfigTab === "config" },
                    attrs: {
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeConfigTab === "config" ? "true" : "false",
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeConfigTab = "config"
                      },
                    },
                  },
                  [_vm._v(" Experiment Configuration ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "rd-module-tab",
                    class: { "is-active": _vm.activeConfigTab === "protocol" },
                    attrs: {
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeConfigTab === "protocol" ? "true" : "false",
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeConfigTab = "protocol"
                      },
                    },
                  },
                  [_vm._v(" Experiment protocol ")]
                ),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  !_vm.hasGeneratedProtocol || _vm.activeConfigTab === "config",
                expression:
                  "!hasGeneratedProtocol || activeConfigTab === 'config'",
              },
            ],
            staticClass: "hypothesis-container section-wrapper",
          },
          [
            !_vm.hasGeneratedProtocol
              ? _c("div", { staticClass: "section-header" }, [
                  _c("h4", [_vm._v("Experiment Configuration")]),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "hypothesis-content",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("h5", [_vm._v("Hypothesis")]),
                _c("div", { staticClass: "textarea-container" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hypothesisText,
                        expression: "hypothesisText",
                      },
                    ],
                    staticClass: "hypothesis-textarea",
                    attrs: {
                      placeholder: "Enter your hypothesis...",
                      rows: "3",
                    },
                    domProps: { value: _vm.hypothesisText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.hypothesisText = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "hypothesis-content",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("h5", [_vm._v("Genes")]),
                _c("div", { staticClass: "textarea-container" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.genesText,
                        expression: "genesText",
                      },
                    ],
                    staticClass: "hypothesis-textarea genes-text-input",
                    attrs: {
                      type: "text",
                      placeholder: "e.g., TP53, BRCA1, MYC",
                    },
                    domProps: { value: _vm.genesText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.genesText = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "hypothesis-content",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("h5", [_vm._v("Experiment Constraints (Optional)")]),
                _c("div", { staticClass: "notes-section" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.experimentConstraints,
                        expression: "experimentConstraints",
                      },
                    ],
                    staticClass: "notes-textarea",
                    attrs: {
                      placeholder:
                        "Add any specific requirements, preferences, or additional considerations for your experiment...",
                      rows: "4",
                    },
                    domProps: { value: _vm.experimentConstraints },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.experimentConstraints = $event.target.value
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "configuration-header",
                    on: { click: _vm.toggleConfigurationSection },
                  },
                  [
                    _c("h5", [
                      _c("span", { staticClass: "configuration-toggle" }, [
                        _vm._v(
                          _vm._s(_vm.showConfigurationSection ? "−" : "+")
                        ),
                      ]),
                      _vm._v(" Advanced Experiment parameters "),
                    ]),
                  ]
                ),
                _vm.showConfigurationSection
                  ? _c("div", { staticClass: "configuration-content" }, [
                      _vm._m(1),
                      _c("div", { staticClass: "experimental-parameters" }, [
                        _c("h5", [_vm._v("Experimental Parameters")]),
                        _c("div", { staticClass: "parameters-grid" }, [
                          _c("div", { staticClass: "filter-section" }, [
                            _c("h5", [_vm._v("Assay Types")]),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-container",
                                on: {
                                  mouseenter: function ($event) {
                                    _vm.showDropdowns.assayTypes = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showDropdowns.assayTypes = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  { staticClass: "dropdown-toggle" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedAssayTypes.length > 0
                                            ? `${_vm.selectedAssayTypes.length} selected`
                                            : "Choose assay types..."
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.showDropdowns.assayTypes
                                  ? _c(
                                      "div",
                                      { staticClass: "dropdown-content" },
                                      _vm._l(
                                        _vm.assay_types.categories,
                                        function (assays, category) {
                                          return _c(
                                            "div",
                                            {
                                              key: category,
                                              staticClass: "category-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "category-header",
                                                },
                                                [_vm._v(_vm._s(category))]
                                              ),
                                              _vm._l(assays, function (assay) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: assay.id,
                                                    staticClass:
                                                      "checkbox-item",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectedAssayTypes,
                                                          expression:
                                                            "selectedAssayTypes",
                                                        },
                                                      ],
                                                      attrs: {
                                                        id: "assay-" + assay.id,
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        value:
                                                          category +
                                                          ":" +
                                                          assay.label,
                                                        checked: Array.isArray(
                                                          _vm.selectedAssayTypes
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectedAssayTypes,
                                                              category +
                                                                ":" +
                                                                assay.label
                                                            ) > -1
                                                          : _vm.selectedAssayTypes,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectedAssayTypes,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v =
                                                                category +
                                                                ":" +
                                                                assay.label,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectedAssayTypes =
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ]))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectedAssayTypes =
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                            }
                                                          } else {
                                                            _vm.selectedAssayTypes =
                                                              $$c
                                                          }
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            "assay-" + assay.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(assay.label)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm.selectedAssayTypes.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "selected-items" },
                                  _vm._l(
                                    _vm.selectedAssayTypes,
                                    function (assayType) {
                                      return _c(
                                        "div",
                                        {
                                          key: assayType,
                                          staticClass: "selected-item",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(assayType.split(":")[1])
                                            ),
                                          ]),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "remove-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeAssayType(
                                                    assayType
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "filter-section" }, [
                            _c("h5", [_vm._v("Cell Types")]),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-container",
                                on: {
                                  mouseenter: function ($event) {
                                    _vm.showDropdowns.cellTypes = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showDropdowns.cellTypes = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  { staticClass: "dropdown-toggle" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedCellTypes.length > 0
                                            ? `${_vm.selectedCellTypes.length} selected`
                                            : "Choose cell types..."
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.showDropdowns.cellTypes
                                  ? _c(
                                      "div",
                                      { staticClass: "dropdown-content" },
                                      _vm._l(
                                        _vm.cell_types.groups,
                                        function (group) {
                                          return _c(
                                            "div",
                                            {
                                              key: group.group,
                                              staticClass: "group-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "group-header" },
                                                [_vm._v(_vm._s(group.group))]
                                              ),
                                              group.options
                                                ? _vm._l(
                                                    group.options,
                                                    function (option) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: option.id,
                                                          staticClass:
                                                            "checkbox-item",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.selectedCellTypes,
                                                                expression:
                                                                  "selectedCellTypes",
                                                              },
                                                            ],
                                                            attrs: {
                                                              id:
                                                                "cell-" +
                                                                option.id,
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              value:
                                                                group.group +
                                                                ":" +
                                                                option.label,
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.selectedCellTypes
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedCellTypes,
                                                                      group.group +
                                                                        ":" +
                                                                        option.label
                                                                    ) > -1
                                                                  : _vm.selectedCellTypes,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.selectedCellTypes,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      group.group +
                                                                      ":" +
                                                                      option.label,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.selectedCellTypes =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.selectedCellTypes =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.selectedCellTypes =
                                                                    $$c
                                                                }
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for:
                                                                  "cell-" +
                                                                  option.id,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  option.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                              group.subgroups
                                                ? _vm._l(
                                                    group.subgroups,
                                                    function (subgroup) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: subgroup.label,
                                                          staticClass:
                                                            "subgroup-section",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "subgroup-header",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subgroup.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            subgroup.options,
                                                            function (option) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: option.id,
                                                                  staticClass:
                                                                    "checkbox-item",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.selectedCellTypes,
                                                                          expression:
                                                                            "selectedCellTypes",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      id:
                                                                        "cell-" +
                                                                        option.id,
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        group.group +
                                                                        ":" +
                                                                        subgroup.label +
                                                                        ":" +
                                                                        option.label,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm.selectedCellTypes
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm.selectedCellTypes,
                                                                              group.group +
                                                                                ":" +
                                                                                subgroup.label +
                                                                                ":" +
                                                                                option.label
                                                                            ) >
                                                                            -1
                                                                          : _vm.selectedCellTypes,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm.selectedCellTypes,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                group.group +
                                                                                ":" +
                                                                                subgroup.label +
                                                                                ":" +
                                                                                option.label,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                (_vm.selectedCellTypes =
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  ))
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                (_vm.selectedCellTypes =
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                            }
                                                                          } else {
                                                                            _vm.selectedCellTypes =
                                                                              $$c
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "cell-" +
                                                                          option.id,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          option.label
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm.selectedCellTypes.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "selected-items" },
                                  _vm._l(
                                    _vm.selectedCellTypes,
                                    function (cellType) {
                                      return _c(
                                        "div",
                                        {
                                          key: cellType,
                                          staticClass: "selected-item",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(cellType.split(":").pop())
                                            ),
                                          ]),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "remove-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeCellType(
                                                    cellType
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "filter-section" }, [
                            _c("h5", [_vm._v("Assay Readouts")]),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-container",
                                on: {
                                  mouseenter: function ($event) {
                                    _vm.showDropdowns.readouts = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showDropdowns.readouts = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  { staticClass: "dropdown-toggle" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedReadouts.length > 0
                                            ? `${_vm.selectedReadouts.length} selected`
                                            : "Choose readouts..."
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.showDropdowns.readouts
                                  ? _c(
                                      "div",
                                      { staticClass: "dropdown-content" },
                                      _vm._l(
                                        _vm.assay_readouts.options,
                                        function (readout) {
                                          return _c(
                                            "div",
                                            {
                                              key: readout.label,
                                              staticClass: "checkbox-item",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.selectedReadouts,
                                                    expression:
                                                      "selectedReadouts",
                                                  },
                                                ],
                                                attrs: {
                                                  id:
                                                    "readout-" + readout.label,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  value: readout.label,
                                                  checked: Array.isArray(
                                                    _vm.selectedReadouts
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectedReadouts,
                                                        readout.label
                                                      ) > -1
                                                    : _vm.selectedReadouts,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.selectedReadouts,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = readout.label,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.selectedReadouts =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.selectedReadouts =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.selectedReadouts = $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "readout-" +
                                                      readout.label,
                                                  },
                                                },
                                                [_vm._v(_vm._s(readout.label))]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm.selectedReadouts.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "selected-items" },
                                  _vm._l(
                                    _vm.selectedReadouts,
                                    function (readout) {
                                      return _c(
                                        "div",
                                        {
                                          key: readout,
                                          staticClass: "selected-item",
                                        },
                                        [
                                          _c("span", [_vm._v(_vm._s(readout))]),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "remove-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeReadout(
                                                    readout
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "experimental-constraints" }, [
                        _c("h5", [_vm._v("Experimental Constraints")]),
                        _c("div", { staticClass: "constraints-grid" }, [
                          _c("div", { staticClass: "constraint-section" }, [
                            _c(
                              "label",
                              { attrs: { for: "throughput-select" } },
                              [_vm._v("Throughput")]
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedThroughput,
                                    expression: "selectedThroughput",
                                  },
                                ],
                                staticClass: "constraint-select",
                                attrs: { id: "throughput-select" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedThroughput = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Choose throughput..."),
                                ]),
                                _c("option", { attrs: { value: "low" } }, [
                                  _vm._v("Low (1-5 conditions)"),
                                ]),
                                _c("option", { attrs: { value: "medium" } }, [
                                  _vm._v("Medium (6-30)"),
                                ]),
                                _c("option", { attrs: { value: "high" } }, [
                                  _vm._v("High (30+)"),
                                ]),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "constraint-section" }, [
                            _c("label", { attrs: { for: "species-select" } }, [
                              _vm._v("Target Species"),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedSpecies,
                                    expression: "selectedSpecies",
                                  },
                                ],
                                staticClass: "constraint-select",
                                attrs: { id: "species-select" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedSpecies = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Choose species..."),
                                ]),
                                _c("option", { attrs: { value: "human" } }, [
                                  _vm._v("Human"),
                                ]),
                                _c("option", { attrs: { value: "rodents" } }, [
                                  _vm._v("Rodents"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "human-rodents" } },
                                  [_vm._v("Human + Rodents")]
                                ),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "constraint-section" }, [
                            _c(
                              "label",
                              { attrs: { for: "timebudget-select" } },
                              [_vm._v("Project Timeline")]
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedTimeBudget,
                                    expression: "selectedTimeBudget",
                                  },
                                ],
                                staticClass: "constraint-select",
                                attrs: { id: "timebudget-select" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedTimeBudget = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Choose timeline..."),
                                ]),
                                _c("option", { attrs: { value: "2-3weeks" } }, [
                                  _vm._v("2-3 weeks"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "1-2months" } },
                                  [_vm._v("1-2 months")]
                                ),
                                _c("option", { attrs: { value: "quarter" } }, [
                                  _vm._v("Quarter-long"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "action-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.reviewAndGenerate },
                },
                [_vm._v("Review & Generate Experiment Plan")]
              ),
            ]),
          ]
        ),
        _vm.hasGeneratedProtocol
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeConfigTab === "protocol",
                    expression: "activeConfigTab === 'protocol'",
                  },
                ],
                staticClass: "section-wrapper",
                class: { collapsed: !_vm.reviewAccordionOpen },
                attrs: { id: "planner-search-draft" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "section-header rd-review-header",
                    attrs: {
                      role: "button",
                      tabindex: "0",
                      "aria-expanded": _vm.reviewAccordionOpen
                        ? "true"
                        : "false",
                      "aria-controls": "rd-review-content",
                    },
                    on: {
                      click: _vm.toggleReviewAccordion,
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          return _vm.toggleReviewAccordion.apply(
                            null,
                            arguments
                          )
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          )
                            return null
                          $event.preventDefault()
                          return _vm.toggleReviewAccordion.apply(
                            null,
                            arguments
                          )
                        },
                      ],
                    },
                  },
                  [
                    _c("h4", [
                      _vm._v(
                        "Review Your Selections & Generate Experiment Plan"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "collapse-icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v(_vm._s(_vm.reviewAccordionOpen ? "▼" : "▶"))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.reviewAccordionOpen,
                        expression: "reviewAccordionOpen",
                      },
                    ],
                    staticClass: "section-content",
                    attrs: { id: "rd-review-content" },
                  },
                  [
                    _c("div", { staticClass: "search-summary" }, [
                      _c("div", { staticClass: "summary-card" }, [
                        _c("div", { staticClass: "config-summary" }, [
                          _c("h6", [_vm._v("Configuration Summary")]),
                          _c("div", { staticClass: "config-grid" }, [
                            _vm.hypothesisText.trim()
                              ? _c("div", { staticClass: "config-item" }, [
                                  _c("strong", [_vm._v("Hypothesis:")]),
                                  _vm._v(
                                    " " + _vm._s(_vm.hypothesisText) + " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.genesText.trim()
                              ? _c("div", { staticClass: "config-item" }, [
                                  _c("strong", [_vm._v("Genes:")]),
                                  _vm._v(" " + _vm._s(_vm.genesText) + " "),
                                ])
                              : _vm._e(),
                            _vm.experimentConstraints.trim()
                              ? _c("div", { staticClass: "config-item" }, [
                                  _c("strong", [
                                    _vm._v("Experiment Constraints:"),
                                  ]),
                                  _c("pre", { staticClass: "rd-review-pre" }, [
                                    _vm._v(_vm._s(_vm.experimentConstraints)),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.selectedAssayTypes.length
                              ? _c("div", { staticClass: "config-item" }, [
                                  _c("strong", [_vm._v("Assay Types:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selectedAssayTypes
                                          .map((at) => at.split(":")[1] || "")
                                          .join(", ")
                                      ) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.selectedCellTypes.length
                              ? _c("div", { staticClass: "config-item" }, [
                                  _c("strong", [_vm._v("Cell Types:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selectedCellTypes
                                          .map(
                                            (ct) => ct.split(":").pop() || ""
                                          )
                                          .join(", ")
                                      ) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.selectedReadouts.length
                              ? _c("div", { staticClass: "config-item" }, [
                                  _c("strong", [_vm._v("Readouts:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.selectedReadouts.join(", ")) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.selectedThroughput ||
                            _vm.selectedSpecies ||
                            _vm.selectedTimeBudget
                              ? _c("div", { staticClass: "config-item" }, [
                                  _c("strong", [_vm._v("Constraints:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.advancedConstraintSummary) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _c("div", { staticClass: "experiment-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                disabled:
                                  !_vm.canGenerateExperiment ||
                                  _vm.isGenerating,
                              },
                              on: { click: _vm.generateExperiment },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isGenerating
                                      ? `Generating Experiment (${_vm.elapsedTime})`
                                      : "Generate Experiment"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm.hasGeneratedProtocol && _vm.activeConfigTab === "protocol"
          ? _c("DesignExperimentResults", {
              attrs: {
                experiments: _vm.experimentResults,
                "is-generating": _vm.isGenerating,
                "elapsed-time": _vm.elapsedTime,
                "error-message": _vm.generationError,
              },
              on: { download: _vm.downloadExperiment },
            })
          : _vm._e(),
      ],
      1
    ),
    _c("input", {
      ref: "importFileInput",
      staticClass: "rd-import-input",
      attrs: { type: "file", accept: "application/json" },
      on: { change: _vm.onImportFileChange },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rd-brand" }, [
      _c("span", { staticClass: "rd-mark" }, [_vm._v("REVEAL")]),
      _c("span", { staticClass: "rd-title" }, [_vm._v("DESIGN")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "user-guidance" }, [
      _c("p", [
        _c("strong", [_vm._v("💡 Tip:")]),
        _vm._v(
          " You can leave any input fields empty if you want the AI to determine the best options for your experiments. The AI will automatically select optimal assay types, cell types, and other parameters based on your hypothesis and data. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }